import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../actions/snackbars';
import * as notificationsActions from '../../actions/notifications';
import {USER_OPTIONS} from '../../utils/constant';
import ReceivedInvitationsView from '../notification/ReceivedInvitationsView';
import InvitationRejectionReason from '../InvitationRejectionReason';
import AcceptSuggestionModal from './AcceptSuggestionModal';

function SuggestedRelationships() {
  const [user, suggestions] = useSelector(state => [state.user, state.notifications.suggestions]);
  const dispatch = useDispatch();

  const [currentInvitation, setCurrentInvitation] = React.useState();
  const [isRejectionModalOpen, setIsRejectionModalOpen] = React.useState(false);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  if (!user?.options?.includes(USER_OPTIONS.SUGGESTION_DISPLAY)) {
    return null;
  }

  function handleOpenRejectionReasonModal(invitation) {
    setIsRejectionModalOpen(true);
    setCurrentInvitation(invitation);
  }

  function handleOpenAcceptSuggestionModal(invitation) {
    setIsAcceptModalOpen(true);
    setCurrentInvitation(invitation);
  }

  function handleAcceptSuggestion() {
    setIsSubmitting(true);
    dispatch(notificationsActions.acceptSuggestion(currentInvitation.invitationId))
      .then(() => {
        dispatch(snackbarsActions.addSuccess(<Translate
          value="client.add.inviteSuccess"
          name={currentInvitation.invitingOrganisationName}
        />));
      })
      .catch(() => {
        snackbarsActions.addError(<Translate value="error.generic"/>);
      })
      .finally(() => {
        setIsAcceptModalOpen(false);
        setIsSubmitting(false);
      });
  }

  function handleCloseRejectionReasonModal() {
    setIsRejectionModalOpen(false);
    setCurrentInvitation({});
  }

  function handleRejectSuccess() {
    dispatch(snackbarsActions.addSuccess(
      <Translate
        value="invitation.suggestion.rejectionSuccess"
        invitingOrganisationName={currentInvitation.invitingOrganisationName}
      />
    ));
  }

  function handleRejectError() {
    dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
  }

  return (
    <>
      <ReceivedInvitationsView
        isSuggestion={true}
        invitations={suggestions}
        onOpenRejectionReasonModal={handleOpenRejectionReasonModal}
        onAcceptInvitation={handleOpenAcceptSuggestionModal}
      />
      <AcceptSuggestionModal
        isOpen={isAcceptModalOpen}
        suggestion={currentInvitation}
        onClose={() => setIsAcceptModalOpen(false)}
        onSubmit={handleAcceptSuggestion}
        submitting={isSubmitting}
      />
      {isRejectionModalOpen &&
        <InvitationRejectionReason
          isSuggestion={true}
          onClose={handleCloseRejectionReasonModal}
          invitation={currentInvitation}
          onSubmitSuccess={handleRejectSuccess}
          onSubmitError={handleRejectError}
        />
      }
    </>
  );
}

export default SuggestedRelationships;
